<template>
  
  <PCHeaderBar v-if="!useIsMobile().value" />
  <div class="search-bar" v-else>
    <HomeSearch :isPreview="true" />
  </div>

  <div class="error-div">
    <img v-lazy="$cvWebpFn(`https://img.kilimall.com/c/h5/error_404.png`, { w: useIsMobile().value ? 360 : 560 })" class="err-img" />
    <div class="tips">
      The page you are trying to access is not available.
    </div>
    <a class="to-home-btn" href="/">
      Go to homepage
    </a>
  </div>
  
  <LazyPCFooter v-if="!useIsMobile().value" />
  <KTabbar v-else />
</template>

<script setup lang="ts">  
useHead({
  meta: [
    { name: 'robots', content: 'noindex, nofollow' },
    { name: 'X-Robots-Tag', content: 'noindex, nofollow' }
  ]
})
</script>

<style scoped lang="scss">
.error-div {
  text-align: center;
  padding: 10vh 0;
  @media screen and (max-width: 360px){
    .err-img{
      width: 80%;
      min-height: 600px;
    }
  }
  @media screen and (min-width: 750px) {
    .err-img{
      height: 560px;
    }
  }
  .tips{
    margin-top: 60px;
  }
  .to-home-btn{
    cursor: pointer;
    width: 400px;
    height: 80px;
    line-height: 80px;
    color: #fff;
    display: inline-block;
    margin-top: 60px;
    background-color: var(--default_color);
    border-radius: 60px;
  }
}
</style>
